"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createPredicateIndexFinder = _interopRequireDefault(require("./_createPredicateIndexFinder.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Returns the first index on an array-like that passes a truth test.
var _default = exports.default = (0, _createPredicateIndexFinder.default)(1);